"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var generate_1 = require("../../generate");
var InputArgs_1 = require("./InputArgs");
var Input = function (params) {
    var args = InputArgs_1.default.parseArgs(params);
    return function (clazz, property) {
        var key = generate_1.setupSchema(clazz);
        clazz[key].properties.push(__assign({}, args, { id: property }));
    };
};
exports.default = Input;
//# sourceMappingURL=Input.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/decorator-form/dist/decorators/input/Input.js
// module id = 256
// module chunks = 0